(function () {
  function initRoot(root) {
    if (!root || root.dataset.shCardRowReady === '1') return;
    root.dataset.shCardRowReady = '1';

    equalise(root);

    /* Images arrive late and change which card is the tallest */
    root.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        equalise(root);
      });
    });
  }

  /* Flickity lays its cells out absolutely, so only a measured min-height
     levels them. A plain grid already matches and keeps the same value. */
  function equalise(root) {
    var cards = root.querySelectorAll('.sh-product-card > .sh-collection__card');
    if (cards.length < 2) return;

    var tallest = 0;

    /* Clear first, else the last run's value is the measurement */
    cards.forEach(function (card) {
      card.style.minHeight = '';
    });

    cards.forEach(function (card) {
      if (card.offsetHeight > tallest) tallest = card.offsetHeight;
    });

    if (!tallest) return;

    cards.forEach(function (card) {
      card.style.minHeight = tallest + 'px';
    });

    if (root.dataset.shCardHeight === String(tallest)) return;
    root.dataset.shCardHeight = String(tallest);

    /* Flickity sizes its viewport from the cells, so ask it to measure again */
    window.dispatchEvent(new Event('resize'));
  }

  var timer = null;

  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(boot, 150);
  }

  function boot() {
    document.querySelectorAll('.product-list').forEach(function (list) {
      if (!list.querySelector('.sh-product-card')) return;

      if (list.dataset.shCardRowReady === '1') {
        equalise(list);
      } else {
        initRoot(list);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  window.addEventListener('resize', onResize);

  /* Colour swatches swap the card image and point the link at that colour.
     The whole card is a link, so the click must not follow it. */
  function pickSwatch(swatch) {
    var card = swatch.closest('.sh-collection__card');
    if (!card) return;

    var img = card.querySelector('.sh-collection__card-media img');
    if (img && swatch.dataset.src) {
      if (!img.dataset.shOriginalSrc) {
        img.dataset.shOriginalSrc = img.getAttribute('src') || '';
      }
      img.setAttribute('loading', 'eager');
      img.srcset = swatch.dataset.srcset || '';
      img.src = swatch.dataset.src;
    }

    if (swatch.dataset.url) card.setAttribute('href', swatch.dataset.url);

    card.querySelectorAll('[data-sh-swatch]').forEach(function (other) {
      other.classList.toggle('is-active', other === swatch);
      other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-sh-swatch]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    pickSwatch(swatch);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var swatch = event.target.closest && event.target.closest('[data-sh-swatch]');
    if (!swatch) return;
    event.preventDefault();
    pickSwatch(swatch);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('.product-list').forEach(initRoot);
  });
})();
